export interface FaqItem { q: string; a: string; }
export interface FaqCategory { title: string; items: FaqItem[]; }

export const FAQ_EXTENDED: FaqCategory[] = [
  {
    title: "Юридические",
    items: [
      { q: "Что если меня уже оштрафовали ФАС?", a: "ERIDON помогает не получить новые штрафы. По действующим — мы поможем подготовить документы для обжалования (есть в тарифе Pro: юр. сопровождение)." },
      { q: "Распространяется ли ФЗ-347 на закрытые Telegram-каналы?", a: "Если канал содержит рекламу третьих лиц — да. Закрытость канала не освобождает от маркировки." },
      { q: "Маркировка взаимного PR — обязательна?", a: "Да. Любая публикация, продвигающая товары/услуги другого лица за вознаграждение (в т.ч. бартер), — реклама." },
      { q: "Как доказать ФАС, что креатив промаркирован?", a: "ERIDON хранит подтверждения от ОРД 5 лет и формирует выписку по запросу за 1 минуту." },
      { q: "Что с рекламой в зарубежных соцсетях?", a: "Если реклама ориентирована на российскую аудиторию — маркировка обязательна. ERIDON выпускает erid и для зарубежных площадок." },
    ],
  },
  {
    title: "Технические",
    items: [
      { q: "Есть ли API?", a: "Да, REST API на тарифах Pro и Agency. Документация публичная." },
      { q: "Можно ли массово выпускать erid из Excel?", a: "Да, импорт XLSX/CSV — до 5 000 строк за раз." },
      { q: "Где хранятся данные?", a: "Серверы в РФ (Москва). Резервные копии — Санкт-Петербург." },
      { q: "Срок хранения отчётов?", a: "5 лет — соответствует требованиям ФАС и Роскомнадзора." },
      { q: "Интеграция с CRM?", a: "Да, webhook-интеграции с amoCRM, Bitrix24, HubSpot. Кастом — на тарифе Agency." },
    ],
  },
  {
    title: "Финансовые",
    items: [
      { q: "Можно ли вернуть деньги?", a: "Да, в течение 14 дней без объяснения причин — возврат 100%." },
      { q: "НДС в чеке?", a: "ИП на УСН — без НДС. Закрывающие документы (акт + счёт) выдаются автоматически." },
      { q: "Оплата по счёту от юрлица?", a: "Да, выставляем счёт на компанию. Подключение в день оплаты." },
      { q: "Есть ли бесплатный доступ?", a: "Да: после регистрации доступен 1 бесплатный ERID. Чтобы продолжить, нужна подписка — от 1 425 ₽/мес (тариф «Старт»)." },
      { q: "Скидки за годовую оплату?", a: "До 30% — действует постоянно. Дополнительно −10% при переходе с конкурента (по запросу)." },
    ],
  },
  {
    title: "О продукте",
    items: [
      { q: "Чем отличаетесь от OneSpot / OrdLab?", a: "Мы единственные с ИИ-проверкой ФЗ-168 (иностранные слова), 4 ОРД из коробки и юридической гарантией компенсации штрафа." },
      { q: "Сколько у вас клиентов?", a: "1 200+ активных подписок. 184 000+ выпущенных erid. 0 штрафов у клиентов с активной подпиской." },
      { q: "Где хранятся мои данные?", a: "На серверах в РФ. ИП-оператор ПД зарегистрирован в реестре Роскомнадзора." },
      { q: "Есть ли сертификаты?", a: "Соответствие ФЗ-152, шифрование TLS 1.3 и AES-256, регулярные пентесты." },
      { q: "Кто стоит за проектом?", a: "Команда юристов и инженеров с 12-летним опытом в digital. Реквизиты ИП — в футере, ЕГРИП доступен на nalog.ru." },
    ],
  },
];
